module.exports = __webpack_public_path__ + "img/caution.b41dc9fb.png";